__turbopack_context__.v({
  "actionBarSkeletonContainer": "Kyj__q_actionBarSkeletonContainer",
  "actionButtonRightContainer": "Kyj__q_actionButtonRightContainer",
  "contentContainer": "Kyj__q_contentContainer",
  "contentWrapper": "Kyj__q_contentWrapper",
  "fullWidthSkeleton": "Kyj__q_fullWidthSkeleton",
  "fullWidthSkeletonNavigationContainer": "Kyj__q_fullWidthSkeletonNavigationContainer",
  "imageSkeletonContainer": "Kyj__q_imageSkeletonContainer",
  "leftColumn": "Kyj__q_leftColumn",
  "privateOfficeHeroImageSkeletonContainer": "Kyj__q_privateOfficeHeroImageSkeletonContainer",
  "rightColumn": "Kyj__q_rightColumn",
  "shimmer": "Kyj__q_shimmer",
  "skeletonDiv": "Kyj__q_skeletonDiv",
  "wrapper": "Kyj__q_wrapper",
});
